import { Controller } from '@hotwired/stimulus';
import { fireChangeEvent } from '../search/accordion_change';
import { parseFormattedNumber } from '../../utils/parse_formatted_number';

export default class NumberRangeBaseController extends Controller {
  static targets = ['from', 'to'];
  static values = { unit: String };

  connect() {
    fireChangeEvent(this.element, this._getDisplayText());
  }

  onChange() {
    this._swapValuesIfToLowerThanFrom();
  }

  _swapValuesIfToLowerThanFrom() {
    if (parseFormattedNumber(this.fromTarget.value) > parseFormattedNumber(this.toTarget.value)) {
      const oldToValue = this.toTarget.value;
      this.toTarget.value = this.fromTarget.value;
      this.fromTarget.value = oldToValue;
    }
    fireChangeEvent(this.element, this._getDisplayText());
  }

  _getUnit() {
    return this.unitValue ?? '';
  }

  _getDisplayText() {
    const values = [];
    if (this.fromTarget.value) {
      values.push(`min: ${this.fromTarget.value} ${this._getUnit()}`);
    }
    if (this.toTarget.value) {
      values.push(`max: ${this.toTarget.value} ${this._getUnit()}`);
    }
    if (values.length === 0) {
      return null;
    }
    return values.join(', ');
  }
}
